import { z } from 'zod';
import type { GrowthRecipeDoc, RecipeSection, CircadianEvent, SectionColor } from '@ledium/types';
import { nameSchema, descriptionSchema } from './primitives.js';

const sectionColorSchema: z.ZodType<SectionColor> = z.object({
    background: z.string(),
    text: z.string()
});

const circadianEventSchema: z.ZodType<CircadianEvent> = z.object({
    lightRecipeId: z.string().nullable(),
    hour: z.number().int().min(0).max(23),
    minute: z.number().int().min(0).max(59),
    sumLightsIntensity: z.number().optional()
});

const recipeSectionSchema: z.ZodType<RecipeSection> = z.object({
    id: z.coerce.string().min(1),
    name: nameSchema,
    orderPosition: z.number().int().min(0),
    repeatNum: z.number().int().min(1).max(500),
    circadianLength: z.number().int().min(1),
    circadianEvents: z.array(circadianEventSchema),
    sectionColor: sectionColorSchema.optional()
});

type GrowthRecipeInput = Omit<GrowthRecipeDoc, '_id' | 'locked' | 'linked'>;

export const growthRecipeSchema: z.ZodType<GrowthRecipeInput> = z.object({
    name: nameSchema,
    description: descriptionSchema,
    sectionList: z.array(recipeSectionSchema)
});
